import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import { faPhone } from '@fortawesome/fontawesome-free-solid'

const Doctor = ({details, englishSelected, englishLanguage, frenchLanguage, handlePopup, popupActive, id, isAnnexeDisplay}) => {

    const requireImage = (image) => {
        try{
            return require(`../img/doctors/${image}`)
        }catch(err){
            return require(`../img/doctors/doctor_icon.png`)
        }
    }
    const doctenaLink = details.doctenaLink
    const doctenaDisplay = details.doctenaDisplay
    const horariesStyle = { marginBottom: '0.5rem' }
    const doctenaStyle = { marginTop: '0.5rem' }


        return (
            <div className="col-xs-12 col-sm-6 col-md-4 doctor__row">
                <div className="doctor-container">
                    <div className="doctor-img-container">
                        <img src={requireImage(details.image)} alt={details.name} />
                    </div>
                    <h3>{details.name}</h3>
                    <h4>{englishSelected ? details.activityEnglish : details.activityFrench}</h4>
                    <h5>{englishSelected ? details.languagesEnglish : details.languagesFrench }</h5>
                    <p className="phoneNumber"><FontAwesomeIcon className="fa" rotation={90} size="1x" icon={faPhone} /> {details.phone}</p>
                    <button className="button center primary mini" style={horariesStyle}>
                        {englishSelected ? englishLanguage.doctorAvailabilities : frenchLanguage.doctorAvailabilities }
                    </button>
                    {doctenaDisplay ?
                        <a href={doctenaLink} className="button center primary mini" style={doctenaStyle}>

                            {englishSelected ? 'Schedule an appointment' : 'Prendre RDV en ligne' }

                        </a> : <p className="colorDanger">
                            {englishSelected ? details.doctenaMessageEn : details.doctenaMessageFr}
                        </p>

                    }
                    <div className="popup">
                        {details.rdv &&
                            <p className="only-on-appointment">
                                {englishSelected ? englishLanguage.appointment : frenchLanguage.appointment}

                            </p>
                        }
                        <table>
                            <tbody>

                            <tr>
                                {englishSelected ? <th>Monday</th> : <th>Lundi</th>}
                                <td>{details.timetable[0].opening_hours[0]}</td>
                                <td>{details.timetable[0].opening_hours[1]}</td>
                            </tr>
                            <tr>
                                {englishSelected ? <th>Tuesday</th> : <th>Mardi</th>}
                                <td>{details.timetable[1].opening_hours[0]}</td>
                                <td>{details.timetable[1].opening_hours[1]}</td>
                            </tr>
                            <tr>
                                {englishSelected ? <th>Wednesday</th> : <th>Mercredi</th>}
                                <td>{details.timetable[2].opening_hours[0]}</td>
                                <td>{details.timetable[2].opening_hours[1]}</td>
                            </tr>
                            <tr>
                                {englishSelected ? <th>Thursday</th> : <th>Jeudi</th>}
                                <td>{details.timetable[3].opening_hours[0]}</td>
                                <td>{details.timetable[3].opening_hours[1]}</td>
                            </tr>
                            <tr>
                                {englishSelected ? <th>Friday</th> : <th>Vendredi</th>}
                                <td>{details.timetable[4].opening_hours[0]}</td>
                                <td>{details.timetable[4].opening_hours[1]}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        )
    

}

export default Doctor